module.exports = __webpack_public_path__ + "static/media/geogebra.ab21cf45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/geogebra.png
// module id = 1724
// module chunks = 2